import { LinearProgress } from "@mui/material";
import { useEffect, useState } from "react";
import {
  createBrowserRouter,
  RouterProvider,
  useNavigate,
} from "react-router-dom";
import { getUser, LOGIN_PAGE, LOGIN_PAGE_CUSTOMER } from "./api/auth";
import GlobalProvider from "./globalComponents/context";
import Admin from "./pages/backoffice/Admin";
import Customers from "./pages/backoffice/Customers";
import CreateCustomer from "./pages/backoffice/Customers/create";
import DetailsCustomer from "./pages/backoffice/Customers/details";
import Dashboard from "./pages/backoffice/Dashboard";
import LoginAdmin from "./pages/backoffice/login";
import Users from "./pages/backoffice/Users";
import CreateUser from "./pages/backoffice/Users/create";
import CreateReward from "./pages/backoffice/Rewards/create";
import CustomerAdmin from "./pages/customerPanel/Admin";
import LoginCustomer from "./pages/customerPanel/loginCustomer/newLogin";
import Main from "./pages/customerPanel/Main";
import Rewards from "./pages/backoffice/Rewards";
import Products from "./pages/backoffice/Products";
import CreateProduct from "./pages/backoffice/Products/create";
import ProductDetails from "./pages/backoffice/Products/details";
import RegisterCustomer from "./pages/customerRegister";
import LandingPage from "./pages/landingPage";

function Page404() {
  return <h1>Page not found!</h1>;
}

const PrivateRoute = ({ component: Component, loginPage, ...rest }) => {
  const [auth, setAuth] = useState({ loading: true, user: null });
  window.pageLogin = loginPage;

  const navigate = useNavigate();

  useEffect(() => {
    const user = getUser();

    try {
      setTimeout(function () {
        if (!user)
          return navigate(loginPage, {
            replace: true,
          });

        setAuth((a) => ({ ...a, loading: false, user }));
      }, 1000);
    } catch (e) {
      //console.log(e);
    }
  }, [navigate]);

  return auth.loading ? (
    <center>
      <LinearProgress />
    </center>
  ) : (
    <Component {...rest} user={auth.user} />
  );
};

const router = createBrowserRouter([
  {
    path: "/ladingpage",
    element: (
      <iframe
        style={{}}
        width="100%"
        height="100%"
        src={"./page.html"}
      ></iframe>
    ),
    errorElement: <Page404 />,
  },
  {
    path: "/",
    element: <LandingPage />,
    errorElement: <Page404 />,
  },
  {
    path: "/login-admin",
    element: <LoginAdmin />,
    errorElement: <Page404 />,
  },
  {
    path: "/login-customer",
    element: <LoginCustomer />,
    errorElement: <Page404 />,
  },
  {
    path: "/customer",
    element: (
      <PrivateRoute component={CustomerAdmin} loginPage={LOGIN_PAGE_CUSTOMER} />
    ),
    children: [{ index: true, element: <Main /> }],
  },
  {
    path: "/customer-register",
    element: <RegisterCustomer />,
    errorElement: <Page404 />,
  },
  {
    path: "/admin",
    element: <PrivateRoute component={Admin} loginPage={LOGIN_PAGE} />,

    children: [
      { index: true, element: <Dashboard /> },

      {
        path: "dashboard",
        element: <Dashboard />,
        errorElement: <Page404 />,
      },

      {
        path: "customers",
        element: <Customers />,
        errorElement: <Page404 />,
      },
      {
        path: "customers/create",
        element: <CreateCustomer />,
        errorElement: <Page404 />,
      },
      {
        path: "customers/:id",
        element: <DetailsCustomer />,
        errorElement: <Page404 />,
      },
      {
        path: "users",
        element: <Users />,
        errorElement: <Page404 />,
      },
      {
        path: "users/create",
        element: <CreateUser />,
        errorElement: <Page404 />,
      },
      {
        path: "products",
        element: <Products />,
        errorElement: <Page404 />,
      },
      {
        path: "products/create",
        element: <CreateProduct />,
        errorElement: <Page404 />,
      },
      {
        path: "products/:id",
        element: <ProductDetails />,
        errorElement: <Page404 />,
      },
      {
        path: "rewards",
        element: <Rewards />,
        errorElement: <Page404 />,
      },
      {
        path: "rewards/create",
        element: <CreateReward />,
        errorElement: <Page404 />,
      },
    ],
  },
]);

function App() {
  return (
    <GlobalProvider>
      <RouterProvider router={router} />
    </GlobalProvider>
  );
}

export default App;
